/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Listado from 'components/public/Listado/Listado';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { fetchCompras } from 'utils/redux/features/comprasSlice';
import { titulosListadoCompras } from 'utils/constants';
import { ListadoCompra } from 'utils/models/interfaces';
import { formatearFechaHoraParaListado, formatearFechaParaListado } from 'utils/utilities';

const esCompraAprobada = (aprobada: ListadoCompra['Aprobada']) => {
  if (typeof aprobada === 'boolean') return aprobada;

  const valorNormalizado = aprobada.trim().toLowerCase();
  return ['true', 'sí', 'si', 'aprobada', 'aprobado', '1'].includes(valorNormalizado);
};

const Compras = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { compras, loadingCompras, errorCompras } = useSelector((state: RootState) => state.compras);
  const error401 = errorCompras?.includes('permisos');

  useEffect(() => {
    dispatch(fetchCompras());
  }, [dispatch]);

  const comprasListado: ListadoCompra[] = compras
    .filter((c: ListadoCompra) => esCompraAprobada(c.Aprobada))
    .map((c: ListadoCompra) => {
      return {
        ...c,
        Aprobada: esCompraAprobada(c.Aprobada) ? 'Sí' : 'No',
        MontoSinDescuento: `$${c.MontoSinDescuento}`,
        GananciaTeatroSinFijoSala: `$${c.GananciaTeatroSinFijoSala}`,
        DescuentoAplicado: `${c.DescuentoAplicado}%`,
        FechaCompra: c.FechaCompra && formatearFechaHoraParaListado(c.FechaCompra.toString()),
        FechaInicioFuncion: c.FechaInicioFuncion && formatearFechaParaListado(c.FechaInicioFuncion.toString()),
      };
    });

  return (
    <>
      {loadingCompras ? (
        <Spinner />
      ) : errorCompras ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Listado
          lista={comprasListado}
          headCells={titulosListadoCompras}
          titulo="Venta de entradas"
          loading={loadingCompras}
        />
      )}
    </>
  );
};

export default Compras;
